import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { useCookieConsent } from '../contexts/CookieConsentContext';
import { setGA4Enabled } from '../common/analytics';

const TEMPORARILY_DISABLED_PAGE_TRACKER = false;

/**
 * Enables GA4 while the calling route is shown and sends its page view under `analyticsPage`;
 * without `analyticsPage` GA4 stays off, so the route sends nothing at all.
 */
export function useAnalyticsPage(analyticsPage: string | undefined) {
	const location = useLocation();
	const { analyticsConsent } = useCookieConsent();
	useEffect(() => {
		if (!analyticsPage) {
			return undefined;
		}
		setGA4Enabled(true);
		if (analyticsConsent && !TEMPORARILY_DISABLED_PAGE_TRACKER) {
			ReactGA.send({ hitType: 'pageview', page: analyticsPage });
		}
		return () => setGA4Enabled(false);
	}, [analyticsPage, location, analyticsConsent]);
}
